var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-horizontal"},[_c('form-input',{attrs:{"form":_vm.form,"property":"name"}}),_vm._v(" "),_c('form-input',{attrs:{"form":_vm.form,"property":"permissions"}},[_c('json-viewer',{model:{value:(_vm.form.permissions),callback:function ($$v) {_vm.$set(_vm.form, "permissions", $$v)},expression:"form.permissions"}})],1)],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37dc1a59","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/forms/Group.vue
// module id = /VOl
// module chunks = 0 1 2